import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { pathOr } from 'ramda';
import TicketType from 'model/tickets/ticketType';
import { useTicketTypesQuery } from 'apollo/queries/TICKET_TYPES';
import { TicketTypesContext } from './TicketTypesContext';
var TicketTypesProvider = function (_a) {
    var children = _a.children;
    var _b = useTicketTypesQuery(), loading = _b.loading, data = _b.data;
    var ticketTypesData = pathOr([], ['ticket_types', 'nodes'], data);
    var ticketTypes = ticketTypesData.map(function (i) { return new TicketType(i); });
    var value = useMemo(function () { return ({ ticketTypes: ticketTypes, ticketTypesLoading: loading }); }, [ticketTypes, loading]);
    return (_jsx(TicketTypesContext.Provider, { value: value, children: children }));
};
export default TicketTypesProvider;
